import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { UserService } from '../../../services/user.service';
import { ThemeService } from '../../../services/theme.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-impersonate',
  templateUrl: './impersonate.page.html',
  styleUrls: ['./impersonate.page.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class ImpersonatePage implements OnInit {
  isLoading = true;
  errorMessage: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private userService: UserService,
    private themeService: ThemeService
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');

    if (!token) {
      this.isLoading = false;
      this.errorMessage = 'No impersonation token provided.';
      return;
    }

    this.handleImpersonation(token);
  }

  private async handleImpersonation(token: string) {
    try {
      await lastValueFrom(this.authService.impersonate(token));

      // Fetch user data and update theme (same as login flow)
      const me = await lastValueFrom(this.userService.fetchMe());
      this.themeService.updateBrandingColor(me.appStyle.idenitityColor);
      this.themeService.updateCtaColor(me.appStyle.primaryButtonColor);

      // Set up available companies if present in user data
      if (me.employees && me.employees.length > 0) {
        this.authService.setAvailableCompaniesFromUser(me.employees);
      }

      // Redirect to home on success
      this.router.navigate(['/p/home']);
    } catch (error) {
      console.error('Impersonation failed:', error);
      this.errorMessage = 'Invalid or expired impersonation token.';
      this.isLoading = false;
    }
  }
}
